import {
    Action,
    API_ITEMS_GET,
    API_ITEMS_GET_DONE,
    API_ITEMS_GET_FAIL,
    API_ITEMS_PATCH,
    API_ITEMS_PATCH_DONE,
    API_ITEMS_PATCH_FAIL,
    USER_LOG_OUT,
} from "../actions";

export type SyncStatusState = `idle` | `syncing` | `error`;

export const syncStatusReducer = (
    state: SyncStatusState = `idle`,
    action: Action,
): SyncStatusState => {
    switch (action.type) {
        case API_ITEMS_GET:
        case API_ITEMS_PATCH:
            return `syncing`;
        case API_ITEMS_GET_DONE:
        case API_ITEMS_PATCH_DONE:
        case USER_LOG_OUT:
            return `idle`;
        case API_ITEMS_GET_FAIL:
        case API_ITEMS_PATCH_FAIL:
            return `error`;
        default:
            return state;
    }
};
